import React from "react";
import Skeleton from "../../Common/Skeleton";

// Skeleton for individual transaction items in the left list
export const TransactionItemSkeleton = ({ className }) => (
  <div className={`flex items-center justify-between rounded-xl p-3 bg-skeleton-end dark:bg-[#2a302b] ${className}`}>
  {/* <div className={`flex items-center justify-between rounded-xl p-3 ${className}`}> */}
    {/* Left: Icon & Text Info */}
    <div className="flex items-center gap-3">
      <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3.5 w-36 sm:w-44 rounded" />
        <Skeleton className="h-2.5 w-24 sm:w-56 rounded" />
      </div>
    </div>

    {/* Right: Amounts */}
    <div className="flex flex-col items-end gap-1.5">
      <Skeleton className="h-3.5 w-16 sm:w-20 rounded" />
      <Skeleton className="h-2.5 w-20 sm:w-24 rounded" />
    </div>
  </div>
);

// Skeleton for the Left Panel (List & Filters)
export const TransactionListPanelSkeleton = () => (
  <div className="flex flex-1 flex-col gap-4 sm:gap-5">
    {/* Desktop Top Bar: Title & Filters side-by-side */}
    <div className="hidden sm:flex items-center justify-between">
      <Skeleton className="h-7 w-40 rounded" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-24 rounded-lg" />
        <Skeleton className="h-9 w-36 rounded-lg" />
        <Skeleton className="h-9 w-10 rounded-lg" />
      </div>
    </div>

    {/* Desktop Search Input */}
    <Skeleton className="hidden sm:block h-11 w-full rounded-xl" />

    {/* Mobile Header Layout (Matching Screenshot) */}
    <div className="flex sm:hidden flex-col gap-4">
      {/* Title Bar with Back Chevron */}
      <div className="relative flex items-center justify-center py-1">
        <Skeleton className="absolute left-0 h-5 w-5 rounded" />
        <Skeleton className="h-6 w-40 rounded" />
      </div>

      {/* Search Bar */}
      <Skeleton className="h-11 w-full rounded-xl" />

      {/* Filter Buttons Row */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-24 rounded-lg" />
        <Skeleton className="h-9 w-36 rounded-lg" />
        <Skeleton className="h-9 w-10 rounded-lg" />
      </div>
    </div>

    {/* Recent Subtitle */}
    <Skeleton className="h-4 w-16 rounded mt-1" />

    {/* Transaction List Cards */}
    <div className="flex flex-col gap-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <TransactionItemSkeleton key={index} />
      ))}
    </div>
  </div>
);

// Skeleton for the Left Panel (List)
export const TransactionListSkeleton = ({ limit = 6 }) => (
  <div className="flex flex-1 flex-col gap-4 sm:gap-5">

    {/* Recent Subtitle */}
    {/* <Skeleton className="h-4 w-16 rounded mt-1" /> */}

    {/* Transaction List Cards */}
    {/* <div className="flex flex-col gap-3 bg-skeleton-end dark:bg-[#2a302b] rounded-xl"> */}
    <div className="flex flex-col gap-3">
      {Array.from({ length: limit }).map((_, index) => (
        <TransactionItemSkeleton key={index} />
      ))}
    </div>
  </div>
);

// Skeleton for the Recent Transactions (List)
export const RecentTransactionListSkeleton = ({recentTrnLimit = 6}) => (
  <Skeleton className="flex flex-1 flex-col gap-4 sm:gap-5 !rounded-2xl">
    
    <div className="flex items-center justify-between pt-4 px-4">
      <Skeleton className="h-3.5 w-36 sm:w-44 rounded-md" />
      <Skeleton className="h-3.5 w-16 sm:w-28 rounded-md" />
    </div>

    {/* Transaction List Cards */}
    {/* <div className="flex flex-col gap-3 bg-skeleton-end dark:bg-[#2a302b] rounded-xl"> */}
    <div className="flex flex-col gap-1 border-t border-divider">
      {Array.from({ length: recentTrnLimit }).map((_, index) => (
        <TransactionItemSkeleton key={index} className={"!rounded-none border-t border-divider"} />
      ))}
    </div>
  </Skeleton>
);

// Skeleton for the Right Panel (Transaction Details)
export const TransactionDetailsPanelSkeleton = ({ isMobile = false }) => (
  <div className="flex w-full flex-col gap-6 lg:w-[420px]">
    {/* Details Header (Shows back chevron on mobile details view) */}
    <div className="flex items-center gap-3">
      {isMobile && <Skeleton className="h-5 w-5 rounded shrink-0 lg:hidden" />}
      <Skeleton className="h-7 w-20 rounded" />
    </div>

    {/* User / Address Header */}
    <div className="flex items-center gap-3">
      <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
      <Skeleton className="h-5 w-full max-w-[280px] sm:w-72 rounded" />
    </div>

    {/* Amount & Status Summary */}
    <div className="flex flex-col items-center justify-center gap-2.5 py-4">
      <Skeleton className="h-4 w-28 rounded" />
      <Skeleton className="h-6 w-24 rounded" />
      <Skeleton className="h-6 w-28 rounded-full mt-1" />
    </div>

    {/* Key-Value Details Box */}
    <div className="flex flex-col gap-5 rounded-xl border border-divider bg-transparent p-5">
      {/* Detail Row */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-4 w-12 rounded" />
        <Skeleton className="h-4 w-36 rounded" />
      </div>

      {/* Detail Row (Multiline value mock) */}
      <div className="flex justify-between items-start">
        <Skeleton className="h-4 w-16 rounded" />
        <div className="flex flex-col items-end gap-1">
          <Skeleton className="h-4 w-36 sm:w-44 rounded" />
          <Skeleton className="h-4 w-8 rounded" />
        </div>
      </div>

      {/* Detail Row */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-4 w-20 rounded" />
        <Skeleton className="h-4 w-16 rounded" />
      </div>

      {/* Detail Row */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-4 w-16 rounded" />
        <Skeleton className="h-4 w-28 rounded" />
      </div>

      {/* Detail Row */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-4 w-10 rounded" />
        <Skeleton className="h-4 w-4 rounded" />
      </div>
    </div>

    {/* Share Button */}
    <Skeleton className="h-12 w-full rounded-xl" />
  </div>
);

// Full Layout Skeleton
const TransactionHistorySkeleton = ({ isDetailsView = false }) => (
  <div className="flex flex-1 flex-col gap-6 sm:gap-9 bg-skeleton-end dark:bg-[#121613] p-4 sm:p-6 rounded-none sm:rounded-[16px] lg:flex-row lg:items-start">
    {/* On mobile, show either details or list depending on state */}
    <div className={`w-full flex-1 ${isDetailsView ? "hidden lg:block" : "block"}`}>
      <TransactionListPanelSkeleton />
    </div>

    {/* Vertical Divider for Desktop */}
    <div
      className="hidden lg:block w-px self-stretch bg-skeleton-end dark:bg-[#2a302b]"
      aria-hidden
    />

    {/* Details Panel View */}
    <div className={`w-full lg:w-auto ${isDetailsView ? "block" : "hidden lg:block"}`}>
      <TransactionDetailsPanelSkeleton isMobile={isDetailsView} />
    </div>
  </div>
);

export default TransactionHistorySkeleton;